function initDosageGuide() {
  document.querySelectorAll('[data-dg]').forEach((root) => {
    if (root.dataset.dgInitialized) return;
    root.dataset.dgInitialized = 'true';

    const cards = Array.from(root.querySelectorAll('[data-dg-card]'));
    if (!cards.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            const card = entry.target;
            const index = cards.indexOf(card);
            setTimeout(() => card.classList.add('is-visible'), Math.max(index, 0) * 90);
            observer.unobserve(card);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    cards.forEach((card) => observer.observe(card));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDosageGuide);
} else {
  initDosageGuide();
}

document.addEventListener('shopify:section:load', initDosageGuide);
